/**
 * author: Qian.qianchen 2019-02-18
 * description: 非原创稿共享
 */
"use strict";
angular.module('shareDocMgrModule', [])
    .controller('shareDocMgrCtrl', ['$scope', "$modalInstance", "modalDialog", "trsHttpService", "selectedArray",
        function($scope, $modalInstance, modalDialog, trsHttpService, selectedArray) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    params: {
                        serviceid: "mlf_sharedoc",
                        methodname: "setAllowNOOriginalShare",
                        isAllowNOOriginalShare: 0,
                        SHARECATEGORYIDS: '',
                    },
                    isSame: true
                }
                $scope.data = {

                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                selectedArray.forEach(function(item, index) {
                    if (index == 0) {
                        $scope.status.params.isAllowNOOriginalShare = item.ALLOWNOORIGSHARE;
                        $scope.status.params.SHARECATEGORYIDS = item.SHARECATEGORYID;
                    } else if ($scope.status.params.isAllowNOOriginalShare != item.ALLOWNOORIGSHARE) {
                        $scope.status.isSame = false;
                    }
                    $scope.status.params.SHARECATEGORYIDS = $scope.status.params.SHARECATEGORYIDS + ',' + item.SHARECATEGORYID;
                });
                
            }
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            }
            /**
             * [confirm description] 确定
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
            	trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, "post").then(function(data) {
            		$scope.status.isSame = true;
            		$modalInstance.close(data);
            	});
            }
        }
    ]);